const returnXml = (
  // qrCodeUrl,
  // imageUrl, 
  userFullName,
   userNameFontSize, 
  //  userEmail, 
  //  emailFontSize, 
  //  userEventName, 
  //  userSeatNo
   ) => {


  // big label print with qr code label
// const labelXml =  `<?xml version="1.0" encoding="utf-8"?>
// <DesktopLabel Version="1">
//   <DYMOLabel Version="3">
//     <Description>DYMO Label</Description>
//     <Orientation>Portrait</Orientation>
//     <LabelName>Shipping S0722430</LabelName>
//     <InitialLength>0</InitialLength>
//     <BorderStyle>SolidLine</BorderStyle>
//     <DYMORect>
//       <DYMOPoint>
//         <X>0.04333337</X>
//         <Y>0.2133333</Y>
//       </DYMOPoint>
//       <Size>
//         <Width>2.026667</Width>
//         <Height>3.696667</Height>
//       </Size>
//     </DYMORect>
//     <BorderColor>
//       <SolidColorBrush>
//         <Color A="1" R="0" G="0" B="0"></Color>
//       </SolidColorBrush>
//     </BorderColor>
//     <BorderThickness>1</BorderThickness>
//     <Show_Border>False</Show_Border>
//     <DynamicLayoutManager>
//       <RotationBehavior>ClearObjects</RotationBehavior>
//       <LabelObjects>
//         <ImageObject>
//           <Name>IImageObject0</Name>
//           <Brushes>
//             <BackgroundBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BackgroundBrush>
//             <BorderBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BorderBrush>
//             <StrokeBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </StrokeBrush>
//             <FillBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </FillBrush>
//           </Brushes>
//           <Rotation>Rotation0</Rotation>
//           <OutlineThickness>1</OutlineThickness>
//           <IsOutlined>False</IsOutlined>
//           <BorderStyle>SolidLine</BorderStyle>
//           <Margin>
//             <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
//           </Margin>
//           <Data>${imageUrl}</Data>
//           <ScaleMode>Uniform</ScaleMode>
//           <HorizontalAlignment>Center</HorizontalAlignment>
//           <VerticalAlignment>Middle</VerticalAlignment>
//           <ObjectLayout>
//             <DYMOPoint>
//               <X>0.137216</X>
//               <Y>0.2133333</Y>
//             </DYMOPoint>
//             <Size>
//               <Width>1.855568</Width>
//               <Height>0.67575</Height>
//             </Size>
//           </ObjectLayout>
//         </ImageObject>
//         <TextObject>
//           <Name>ITextObject0</Name>
//           <Brushes>
//             <BackgroundBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BackgroundBrush>
//             <BorderBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BorderBrush>
//             <StrokeBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </StrokeBrush>
//             <FillBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </FillBrush>
//           </Brushes>
//           <Rotation>Rotation0</Rotation>
//           <OutlineThickness>1</OutlineThickness>
//           <IsOutlined>False</IsOutlined>
//           <BorderStyle>SolidLine</BorderStyle>
//           <Margin>
//             <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
//           </Margin>
//           <HorizontalAlignment>Center</HorizontalAlignment>
//           <VerticalAlignment>Top</VerticalAlignment>
//           <FitMode>None</FitMode>
//           <IsVertical>False</IsVertical>
//           <FormattedText>
//             <FitMode>None</FitMode>
//             <HorizontalAlignment>Center</HorizontalAlignment>
//             <VerticalAlignment>Top</VerticalAlignment>
//             <IsVertical>False</IsVertical>
//             <LineTextSpan>
//               <TextSpan>
//                 <Text>${userFullName}</Text>
//                 <FontInfo>
//                   <FontName>Arial</FontName>
//                   <FontSize>${userNameFontSize}</FontSize>
//                   <IsBold>True</IsBold>
//                   <IsItalic>False</IsItalic>
//                   <IsUnderline>False</IsUnderline>
//                   <FontBrush>
//                     <SolidColorBrush>
//                       <Color A="1" R="0" G="0" B="0"></Color>
//                     </SolidColorBrush>
//                   </FontBrush>
//                 </FontInfo>
//               </TextSpan>
//             </LineTextSpan>
//           </FormattedText>
//           <ObjectLayout>
//             <DYMOPoint>
//               <X>0.07333319</X>
//               <Y>1.050255</Y>
//             </DYMOPoint>
//             <Size>
//               <Width>1.996667</Width>
//               <Height>0.2880986</Height>
//             </Size>
//           </ObjectLayout>
//         </TextObject>
//         <TextObject>
//           <Name>ITextObject1</Name>
//           <Brushes>
//             <BackgroundBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BackgroundBrush>
//             <BorderBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BorderBrush>
//             <StrokeBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </StrokeBrush>
//             <FillBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </FillBrush>
//           </Brushes>
//           <Rotation>Rotation0</Rotation>
//           <OutlineThickness>1</OutlineThickness>
//           <IsOutlined>False</IsOutlined>
//           <BorderStyle>SolidLine</BorderStyle>
//           <Margin>
//             <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
//           </Margin>
//           <HorizontalAlignment>Center</HorizontalAlignment>
//           <VerticalAlignment>Top</VerticalAlignment>
//           <FitMode>None</FitMode>
//           <IsVertical>False</IsVertical>
//           <FormattedText>
//             <FitMode>None</FitMode>
//             <HorizontalAlignment>Center</HorizontalAlignment>
//             <VerticalAlignment>Top</VerticalAlignment>
//             <IsVertical>False</IsVertical>
//             <LineTextSpan>
//               <TextSpan>
//                 <Text>${userEmail}</Text>
//                 <FontInfo>
//                   <FontName>Arial</FontName>
//                   <FontSize>${emailFontSize}</FontSize>
//                   <IsBold>True</IsBold>
//                   <IsItalic>False</IsItalic>
//                   <IsUnderline>False</IsUnderline>
//                   <FontBrush>
//                     <SolidColorBrush>
//                       <Color A="1" R="0" G="0" B="0"></Color>
//                     </SolidColorBrush>
//                   </FontBrush>
//                 </FontInfo>
//               </TextSpan>
//             </LineTextSpan>
//           </FormattedText>
//           <ObjectLayout>
//             <DYMOPoint>
//               <X>0.04333337</X>
//               <Y>1.369459</Y>
//             </DYMOPoint>
//             <Size>
//               <Width>2.006667</Width>
//               <Height>0.2816238</Height>
//             </Size>
//           </ObjectLayout>
//         </TextObject>
//         <TextObject>
//           <Name>ITextObject2</Name>
//           <Brushes>
//             <BackgroundBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BackgroundBrush>
//             <BorderBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BorderBrush>
//             <StrokeBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </StrokeBrush>
//             <FillBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </FillBrush>
//           </Brushes>
//           <Rotation>Rotation0</Rotation>
//           <OutlineThickness>1</OutlineThickness>
//           <IsOutlined>False</IsOutlined>
//           <BorderStyle>SolidLine</BorderStyle>
//           <Margin>
//             <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
//           </Margin>
//           <HorizontalAlignment>Center</HorizontalAlignment>
//           <VerticalAlignment>Top</VerticalAlignment>
//           <FitMode>None</FitMode>
//           <IsVertical>False</IsVertical>
//           <FormattedText>
//             <FitMode>None</FitMode>
//             <HorizontalAlignment>Center</HorizontalAlignment>
//             <VerticalAlignment>Top</VerticalAlignment>
//             <IsVertical>False</IsVertical>
//             <LineTextSpan>
//               <TextSpan>
//                 <Text>${userEventName}</Text>
//                 <FontInfo>
//                   <FontName>Arial</FontName>
//                   <FontSize>8</FontSize>
//                   <IsBold>True</IsBold>
//                   <IsItalic>False</IsItalic>
//                   <IsUnderline>False</IsUnderline>
//                   <FontBrush>
//                     <SolidColorBrush>
//                       <Color A="1" R="0" G="0" B="0"></Color>
//                     </SolidColorBrush>
//                   </FontBrush>
//                 </FontInfo>
//               </TextSpan>
//             </LineTextSpan>
//           </FormattedText>
//           <ObjectLayout>
//             <DYMOPoint>
//               <X>0.04333337</X>
//               <Y>1.609852</Y>
//             </DYMOPoint>
//             <Size>
//               <Width>2.026667</Width>
//               <Height>0.2037971</Height>
//             </Size>
//           </ObjectLayout>
//         </TextObject>
//         <QRCodeObject>
//           <Name>IQRCodeObject0</Name>
//           <Brushes>
//             <BackgroundBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="1" G="1" B="1"></Color>
//               </SolidColorBrush>
//             </BackgroundBrush>
//             <BorderBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BorderBrush>
//             <StrokeBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </StrokeBrush>
//             <FillBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </FillBrush>
//           </Brushes>
//           <Rotation>Rotation0</Rotation>
//           <OutlineThickness>1</OutlineThickness>
//           <IsOutlined>False</IsOutlined>
//           <BorderStyle>SolidLine</BorderStyle>
//           <Margin>
//             <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
//           </Margin>
//           <BarcodeFormat>QRCode</BarcodeFormat>
//           <Data>
//             <DataString>URL:</DataString>
//           </Data>
//           <HorizontalAlignment>Center</HorizontalAlignment>
//           <VerticalAlignment>Middle</VerticalAlignment>
//           <Size>AutoFit</Size>
//           <EQRCodeType>QRCodeWebPage</EQRCodeType>
//           <WebAddressDataHolder>
//             <DataString>${qrCodeUrl}</DataString>
//           </WebAddressDataHolder>
//           <ObjectLayout>
//             <DYMOPoint>
//               <X>0.7003888</X>
//               <Y>2.349583</Y>
//             </DYMOPoint>
//             <Size>
//               <Width>0.6826903</Width>
//               <Height>0.7637147</Height>
//             </Size>
//           </ObjectLayout>
//         </QRCodeObject>
//         <TextObject>
//           <Name>ITextObject3</Name>
//           <Brushes>
//             <BackgroundBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BackgroundBrush>
//             <BorderBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BorderBrush>
//             <StrokeBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </StrokeBrush>
//             <FillBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </FillBrush>
//           </Brushes>
//           <Rotation>Rotation0</Rotation>
//           <OutlineThickness>1</OutlineThickness>
//           <IsOutlined>False</IsOutlined>
//           <BorderStyle>SolidLine</BorderStyle>
//           <Margin>
//             <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
//           </Margin>
//           <HorizontalAlignment>Center</HorizontalAlignment>
//           <VerticalAlignment>Top</VerticalAlignment>
//           <FitMode>None</FitMode>
//           <IsVertical>False</IsVertical>
//           <FormattedText>
//             <FitMode>None</FitMode>
//             <HorizontalAlignment>Center</HorizontalAlignment>
//             <VerticalAlignment>Top</VerticalAlignment>
//             <IsVertical>False</IsVertical>
//             <LineTextSpan>
//               <TextSpan>
//                 <Text>Scan to Book Planner</Text>
//                 <FontInfo>
//                   <FontName>Arial</FontName>
//                   <FontSize>8</FontSize>
//                   <IsBold>True</IsBold>
//                   <IsItalic>False</IsItalic>
//                   <IsUnderline>False</IsUnderline>
//                   <FontBrush>
//                     <SolidColorBrush>
//                       <Color A="1" R="0" G="0" B="0"></Color>
//                     </SolidColorBrush>
//                   </FontBrush>
//                 </FontInfo>
//               </TextSpan>
//             </LineTextSpan>
//           </FormattedText>
//           <ObjectLayout>
//             <DYMOPoint>
//               <X>0.2746506</X>
//               <Y>3.132962</Y>
//             </DYMOPoint>
//             <Size>
//               <Width>1.534933</Width>
//               <Height>0.2002532</Height>
//             </Size>
//           </ObjectLayout>
//         </TextObject>
//         <ImageObject>
//           <Name>IImageObject1</Name>
//           <Brushes>
//             <BackgroundBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BackgroundBrush>
//             <BorderBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BorderBrush>
//             <StrokeBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </StrokeBrush>
//             <FillBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </FillBrush>
//           </Brushes>
//           <Rotation>Rotation0</Rotation>
//           <OutlineThickness>1</OutlineThickness>
//           <IsOutlined>False</IsOutlined>
//           <BorderStyle>SolidLine</BorderStyle>
//           <Margin>
//             <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
//           </Margin>
//           <Data>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</Data>
//           <ScaleMode>Uniform</ScaleMode>
//           <HorizontalAlignment>Center</HorizontalAlignment>
//           <VerticalAlignment>Middle</VerticalAlignment>
//           <ObjectLayout>
//             <DYMOPoint>
//               <X>0.437907</X>
//               <Y>3.473611</Y>
//             </DYMOPoint>
//             <Size>
//               <Width>1.346108</Width>
//               <Height>0.3561032</Height>
//             </Size>
//           </ObjectLayout>
//         </ImageObject>
//         <ShapeObject>
//           <Name>IShapeObject0</Name>
//           <Brushes>
//             <BackgroundBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BackgroundBrush>
//             <BorderBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BorderBrush>
//             <StrokeBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </StrokeBrush>
//             <FillBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </FillBrush>
//           </Brushes>
//           <Rotation>Rotation0</Rotation>
//           <OutlineThickness>1</OutlineThickness>
//           <IsOutlined>False</IsOutlined>
//           <BorderStyle>SolidLine</BorderStyle>
//           <Margin>
//             <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
//           </Margin>
//           <StrokeWidth>1</StrokeWidth>
//           <DashPattern>LongDashes</DashPattern>
//           <ShapeType>RoundedRectangle</ShapeType>
//           <ObjectLayout>
//             <DYMOPoint>
//               <X>0.3416707</X>
//               <Y>2.256883</Y>
//             </DYMOPoint>
//             <Size>
//               <Width>1.375023</Width>
//               <Height>1.153832</Height>
//             </Size>
//           </ObjectLayout>
//         </ShapeObject>
//         <TextObject>
//           <Name>ITextObject4</Name>
//           <Brushes>
//             <BackgroundBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BackgroundBrush>
//             <BorderBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </BorderBrush>
//             <StrokeBrush>
//               <SolidColorBrush>
//                 <Color A="1" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </StrokeBrush>
//             <FillBrush>
//               <SolidColorBrush>
//                 <Color A="0" R="0" G="0" B="0"></Color>
//               </SolidColorBrush>
//             </FillBrush>
//           </Brushes>
//           <Rotation>Rotation0</Rotation>
//           <OutlineThickness>1</OutlineThickness>
//           <IsOutlined>False</IsOutlined>
//           <BorderStyle>SolidLine</BorderStyle>
//           <Margin>
//             <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
//           </Margin>
//           <HorizontalAlignment>Center</HorizontalAlignment>
//           <VerticalAlignment>Top</VerticalAlignment>
//           <FitMode>None</FitMode>
//           <IsVertical>False</IsVertical>
//           <FormattedText>
//             <FitMode>None</FitMode>
//             <HorizontalAlignment>Center</HorizontalAlignment>
//             <VerticalAlignment>Top</VerticalAlignment>
//             <IsVertical>False</IsVertical>
//             <LineTextSpan>
//               <TextSpan>
//                 <Text>${userSeatNo}</Text>
//                 <FontInfo>
//                   <FontName>Arial</FontName>
//                   <FontSize>12</FontSize>
//                   <IsBold>True</IsBold>
//                   <IsItalic>False</IsItalic>
//                   <IsUnderline>False</IsUnderline>
//                   <FontBrush>
//                     <SolidColorBrush>
//                       <Color A="1" R="0" G="0" B="0"></Color>
//                     </SolidColorBrush>
//                   </FontBrush>
//                 </FontInfo>
//               </TextSpan>
//             </LineTextSpan>
//           </FormattedText>
//           <ObjectLayout>
//             <DYMOPoint>
//               <X>0.04333337</X>
//               <Y>1.851574</Y>
//             </DYMOPoint>
//             <Size>
//               <Width>2.026667</Width>
//               <Height>0.2432056</Height>
//             </Size>
//           </ObjectLayout>
//         </TextObject>
//       </LabelObjects>
//     </DynamicLayoutManager>
//   </DYMOLabel>
//   <LabelApplication>Blank</LabelApplication>
//   <DataTable>
//     <Columns></Columns>
//     <Rows></Rows>
//   </DataTable>
// </DesktopLabel>`


const labelXml = `<?xml version="1.0" encoding="utf-8"?>
<DesktopLabel Version="1">
  <DYMOLabel Version="3">
    <Description>DYMO Label</Description>
    <Orientation>Landscape</Orientation>
    <LabelName>Addresss0722370</LabelName>
    <InitialLength>0</InitialLength>
    <BorderStyle>SolidLine</BorderStyle>
    <DYMORect>
      <DYMOPoint>
        <X>0.23</X>
        <Y>0.06</Y>
      </DYMOPoint>
      <Size>
        <Width>3.21</Width>
        <Height>0.9966666</Height>
      </Size>
    </DYMORect>
    <BorderColor>
      <SolidColorBrush>
        <Color A="1" R="0" G="0" B="0"></Color>
      </SolidColorBrush>
    </BorderColor>
    <BorderThickness>1</BorderThickness>
    <Show_Border>False</Show_Border>
    <DynamicLayoutManager>
      <RotationBehavior>ClearObjects</RotationBehavior>
      <LabelObjects>
        <TextObject>
          <Name>ITextObject0</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>Center</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>${userFullName}</Text>
                <FontInfo>
                  <FontName>Segoe UI</FontName>
                  <FontSize>26.4</FontSize>
                  <IsBold>True</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>0.2347927</X>
              <Y>0.2440625</Y>
            </DYMOPoint>
            <Size>
              <Width>3.204592</Width>
              <Height>0.4983334</Height>
            </Size>
          </ObjectLayout>
        </TextObject>
      </LabelObjects>
    </DynamicLayoutManager>
  </DYMOLabel>
  <LabelApplication>Blank</LabelApplication>
  <DataTable>
    <Columns></Columns>
    <Rows></Rows>
  </DataTable>
</DesktopLabel>`

return { labelXml } 

}

export default returnXml;